import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MasterService } from 'src/app/services/master.service';
import { StoreService } from 'src/app/services/store.service';
import * as words from '../../services/language'
import { MessageService } from 'src/app/services/message.service';
import { GPSInventoryListComponent } from "./gps-inventory-assignment/gps-inventory-list/gps-inventory-list.component";
import { GpsDevice } from 'src/app/models/gps-device.model';
import { IntegrationConfig } from 'src/app/models/integration-config.model';

@Component({
    selector: 'app-gps',
    templateUrl: './gps.component.html',
    styleUrls: ['./gps.component.scss'],
    standalone: false
})
export class GpsComponent implements OnInit {

    /** Listen for input commit (enter key) events if further processing is necessary. */
    @Output() refreshEmitter$: EventEmitter<Object> = new EventEmitter()

    @ViewChild(GPSInventoryListComponent, { static: false }) childC: GPSInventoryListComponent;

    // set all words
    protected words = words.language

    // save all data by type
    protected vehicles: Object[] = [];

    protected language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'

    protected gpsDevices: GpsDevice[] = []

    protected unassigned: GpsDevice[] = [];

    protected assigned: GpsDevice[];

    protected inactive: GpsDevice[];

    protected assignedData: {};

    protected gpsDeviceInformation = new FormGroup({
        id: new FormControl<number>(0),
        productName: new FormControl<string | null>(null),
        serialNumber: new FormControl<number>(0),
        status: new FormControl<string>("Unassigned"),
        integrationCompanyId: new FormControl<number | null>(null, [Validators.required]),
        notes: new FormControl<string | null>(null),
        expiryDate: new FormControl<string | null>(null)
    })

    protected gpsProviders: IntegrationConfig[] = [];

    protected refresh: boolean;

    protected loading: boolean;

    constructor(private master: MasterService, private ms: MessageService, private store: StoreService, private fb: FormBuilder) { }

    onUpdateChild() {
        this.childC.update();
    }

    ngOnInit() {
        this.listGPSDevices()
        this.listGPSProviders()
    }

    protected listGPSProviders = () => {
        this.master.get('corporation/integrations?category=gps&enabled=true', res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.gpsProviders = res.data.integrations
        })
    }

    // todo: listen to output of navbar
    protected listenerNav = (e): void => {
        switch (e['message']) {
            case 'changeLanguage':
                this.language = e['value']
                break
        }
    }

    protected listGPSDevices = () => {
        this.loading = true
        this.master.get('gpsDevices', res => {
            this.loading = false
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.gpsDevices = res.data.gpsDevices
            this.unassigned = this.gpsDevices.length > 0 ? this.gpsDevices.filter(gpsDevice => gpsDevice['status'] == 'Unassigned') : null
            this.assigned = this.gpsDevices.length > 0 ? this.gpsDevices.filter(gpsDevice => gpsDevice['status'] == 'Assigned') : null
            this.inactive = this.gpsDevices.length > 0 ? this.gpsDevices.filter(gpsDevice => gpsDevice['status'] == 'Inactive') : null
        })
    }

    protected listenerChildrens = (e) => {
        switch (e.message) {
            case "refreshList":
                this.listGPSDevices()
                this.onUpdateChild()
                break;
            default:
                break;
        }
    }

    public editSetup = (data: any) => {
        this.gpsDeviceInformation.patchValue(data)
        document.getElementById('gps-device').click()
    }

    public resetGPSDeviceInformation = () => {
        this.gpsDeviceInformation.reset()
        this.assignedData = null
    }

    public saveDevice = () => {
        const identity = this.gpsDeviceInformation.get('id').value
        if (!identity || isNaN(identity) || (identity <= 0)) {
            this.addGPSDevice()
            return
        }

        this.updateGPSDevice()

    }

    public addGPSDevice = () => {
        let payload = this.gpsDeviceInformation.value
        this.master.post('gpsDevice', { information: payload }, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            document.getElementById('btn-close-modal-gps-device').click()
            this.listGPSDevices()
        })
    }

    public updateGPSDevice = () => {
        let payload = this.gpsDeviceInformation.value
        this.master.put(`gpsDevice/${payload.id}`, { information: payload }, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            document.getElementById('btn-close-modal-gps-device').click()
            this.listGPSDevices()
            // this.onUpdateChild()
        })
    }
}
